/* eslint-disable consistent-return */
import { yupResolver } from '@hookform/resolvers/yup';
import { Typography, Button } from '@mui/material';
import { useCallback, useRef } from 'react';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { toast } from 'react-toastify';

import { Input } from '../../../../components/Input';
import { InputPassword } from '../../../../components/InputPassword';
import { TurnstileWidget } from '../../../../components/TurnstileWidget';

import { ContainerSubLogin } from './styles';

import { AuthSectionSteps } from '../../types/AuthSectionSteps';
import {
  Company,
  setTokensLocalStorage,
  signInRequest,
} from '../../../../services';
import api from '../../../../services/api';

import useAuthStore from '../../../../store/auth';
import useCompanyStore from '../../../../store/companies';

import { useAuth } from '../../hooks/useAuth';

interface LoginPageProps {
  setStepLogin: (step: AuthSectionSteps) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
}

const hasCaptcha = process.env.REACT_APP_TURNSTILE_ENABLED || 'false';

export const LoginPage = ({
  setStepLogin,
  isLoading,
  setIsLoading,
}: LoginPageProps) => {
  const { setUser } = useAuthStore(state => state);
  const { setCompanies } = useCompanyStore(state => state);

  const { handleRedirect } = useAuth();

  const turnstileRef = useRef<HTMLDivElement | null>(null);

  const formValidation = useCallback(() => {
    return Yup.object().shape({
      email: Yup.string()
        .email('Digite um e-mail válido')
        .required('O campo E-mail é obrigatório.'),
    });
  }, []);

  const { control, handleSubmit, watch } = useForm({
    resolver: yupResolver(formValidation()),
  });

  const tokenValue = watch('token');
  const btnIsDisabledByCaptcha =
    hasCaptcha === 'true' && tokenValue === undefined;

  const handleLogin = async (formData: any) => {
    setIsLoading(true);

    try {
      const response = await signInRequest({
        email: formData?.email,
        password: formData?.password,
        token: formData?.token,
      });

      if (response?.status === 200) {
        const { user, access_token, refresh_token, companies } = response.data;
        if (response?.data?.mfaRequired === false) {
          const companiesActives = companies?.filter((c: Company) => c.status);
          api().defaults.headers.common.Authorization = `Bearer ${access_token}`;
          const tokens = {
            access_token,
            refresh_token,
          };

          setUser(user);
          setTokensLocalStorage(tokens);

          if (user?.profile) {
            if (companiesActives?.length === 0) {
              return setStepLogin(AuthSectionSteps.NO_LINKED_COMPANIES);
            }

            setCompanies([...companiesActives]);
            handleRedirect(user, companiesActives, setIsLoading, setStepLogin);
          }
        } else {
          setIsLoading(false);
          setUser(user);
          setStepLogin(AuthSectionSteps.AUTHENTICATION);
        }
      }
    } catch (error: any) {
      console.error('[Erro handleLogin]:', error);

      setIsLoading(false);
      if (error?.response?.status === 500) {
        toast.error('Erro desconhecido, contate o suporte');
      } else {
        toast.error(error?.response?.data?.message);
      }
    }
  };

  return (
    <>
      <div className="form-login">
        <section className="header">
          <Typography className="title">Fazer Login</Typography>
        </section>
        <Input
          className="email"
          id="outlined-basic"
          label="Digite seu e-mail"
          name="email"
          control={control}
        />
        <InputPassword
          className="password"
          id="outlined-password-input"
          label="Sua senha"
          name="password"
          autoComplete="current-password"
          control={control}
          required
        />

        <TurnstileWidget
          control={control}
          name="token"
          turnstileRef={turnstileRef}
        />

        <Button
          variant="contained"
          color="primary"
          className="submit-btn"
          type="button"
          disabled={isLoading || btnIsDisabledByCaptcha}
          onClick={handleSubmit(handleLogin)}
        >
          Entrar
        </Button>
      </div>

      <ContainerSubLogin>
        <Button
          variant="text"
          onClick={() => setStepLogin(AuthSectionSteps.RECOVER_PASSWORD)}
          className="register"
        >
          <b className="register-texto">Esqueci minha senha</b>
        </Button>
      </ContainerSubLogin>
    </>
  );
};
